

























































































































import Vue from "vue";
import AppIcon from "@/components/app-icon.vue";
import InformationCard from "@/features/information/components/information-card.vue";
import { Autorisations } from "@/models/Autorisations";

export default Vue.extend({
  props: {
    autorisations: {
      type: Array,
    },
  },
  components: {
    AppIcon,
    InformationCard,
  },
  methods: {
  /**
    INSERT INTO infa_typeautorisation(id, intitule) VALUES (-1, 'CDAP');
    INSERT INTO infa_typeautorisation(id, intitule) VALUES (-2, 'Rentrer seul');
    INSERT INTO infa_typeautorisation(id, intitule) VALUES (-3, 'Hospitalisation');
    INSERT INTO infa_typeautorisation(id, intitule) VALUES (-4, 'Prise de médicaments');
    INSERT INTO infa_typeautorisation(id, intitule) VALUES (-5, 'Photographie');
    INSERT INTO infa_typeautorisation(id, intitule) VALUES (-6, 'Diffusion photos/vidéo');
    INSERT INTO infa_typeautorisation(id, intitule) VALUES (-7, 'Sortie');
    INSERT INTO infa_typeautorisation(id, intitule) VALUES (-8, 'Transport');
  */
    affichageEdition(id: number){
      let autorisations : Array<Autorisations> = this.autorisations as Array<Autorisations>
      let auto = autorisations.find(
        (item: Autorisations) =>
          item.getTypeautorisation_id() === id && item.isMobi()
      );
      if (typeof auto === "undefined") {
        return 0;
      } else {
        return auto.getAffichageedition();
      }
    },
  },
});
